import { UIText3 } from '@cian/ui-kit';
import * as React from 'react';

// @ts-expect-error TODO: исправить импорт картинок
import userImg from './assets/user.svg';
import * as styles from './styles.css';

type TUserCardProfileLink = {
  userProfileUrl: string;
  onClick(): void;
};

export const UserCardProfileLink: React.FC<TUserCardProfileLink> = ({ userProfileUrl, onClick }) => {
  return (
    <a
      href={userProfileUrl}
      className={styles['profile_button']}
      onClick={onClick}
      data-testid="UserCardProfileLink"
      target="_blank"
      rel="noreferrer"
    >
      <img src={userImg} width={24} height={24} />
      <UIText3 color="text-main-default">Профиль</UIText3>
    </a>
  );
};
